import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOkHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M30 60V38m-10 4v14a4 4 0 0 0 4 4h26.853a6 6 0 0 0 5.93-5.088l2.154-14c.559-3.634-2.253-6.912-5.93-6.912H46a2 2 0 0 1-2-2v-7.068A4.93 4.93 0 0 0 39.068 20c-.65 0-1.238.383-1.502.976l-7.038 15.836A2 2 0 0 1 28.7 38H24a4 4 0 0 0-4 4"
    />
  </svg>
);
export default SvgOkHand;
